const variantForm = document.querySelector("variant-selects");
const radios = variantForm?.querySelectorAll("label:has(input[type=radio])");
const tables = document.querySelectorAll(".product__accordion table.product-table--feeding");
const calorieCounts = document.querySelectorAll(".calories.rte.feeding");
const textElements = document.querySelectorAll(".variant-table-text");
const asideElements = document.querySelectorAll(".accordion__content.rte aside");
document.addEventListener("variantChanged", showTables)

function showTables(e) {
  const variantTitle = e.detail;

  hideAll(textElements);
  hideAll(calorieCounts);
  hideAll(asideElements);
  hideAll(tables);

  showTable(variantTitle);
}

function hideAll(elements) {
  elements?.forEach(el => el.classList.add("hidden")); 
}

function showByVariantTitle(variantTitle, elementType) {
  document.getElementById(variantTitle+"-"+elementType)?.classList.remove("hidden");
}

function showTable(variantTitle) {
  showByVariantTitle(variantTitle, "calories");
  showByVariantTitle(variantTitle, "text");
  showByVariantTitle(variantTitle, "aside");
  showByVariantTitle(variantTitle, "table");
}
